import React from 'react';

const Page = ({to, content, ...props }) => (
      <div className="content-wrapper">
        <div className="content">
          {content}
        </div>
      </div>
)

export default Page;